import { Injectable } from "@angular/core";
import { HttpBackend } from "@angular/common/http";
import { CfgService } from "../../../../cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class AbsencesCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class AbsencesKpiCfg {
  public absences: AbsencesCfg;
}

@Injectable()
export class AbsencesKpiCfgService extends CfgService<AbsencesKpiCfg> {
  json: any = {
    absences: {
      summaryEndpointPattern: "%{DashboardApiUrl}/absences/{0}?date={1}",
      detailEndpointPattern: "%{DashboardApiUrl}/absences/{0}/detail?date={1}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/absencesKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
